var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Col, Form, Row } from "@brushfire/ui";
import { useContext, useEffect, useState } from "react";
import Constants from "../../../data/constants";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { getAttendeeGroups, putAttendeeGroup, validateGroupPasscode } from "../../../data/api";
import { useDispatch } from "react-redux";
import { handleErrors } from "../../../data/helpers";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { AppFormContext } from "../../../App";
import WidgetSticky from "../../Helpers/WidgetSticky";
import Skeleton from "@material-ui/lab/Skeleton";
import * as Yup from "yup";
import NoChangesAfterMessage from "./NoChangesAfterMessage";
var MyAttendeeGroupChange = function (_a) {
    var eventData = _a.eventData, attendee = _a.attendee, path = _a.path, setConfirmationMessage = _a.setConfirmationMessage, refreshAttendeeList = _a.refreshAttendeeList, order = _a.order, group = _a.group;
    var _b = __read(useState(), 2), groupData = _b[0], setGroupData = _b[1];
    var _c = __read(useState(false), 2), showGroupResults = _c[0], setShowGroupResults = _c[1];
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var formikContext = useContext(AppFormContext).formikContext;
    useEffect(function () {
        if ([Constants.Routes.myAttendeeGroup].includes(path)) {
            getAttendeeGroups(attendee.id)
                .then(function (_a) {
                var data = _a.data;
                setGroupData(data);
            })
                .catch(function (err) {
                handleErrors(err, dispatch, formikContext);
            });
        }
    }, [path]);
    var onSubmit = function (values, formikHelpers, setGlobalError) {
        validateGroupPasscode({
            groupName: values.groupName,
            joinCode: values.joinCode,
            eventId: eventData.id,
        })
            .then(function (_a) {
            var data = _a.data;
            putAttendeeGroup(attendee.id, { groupId: data, joinCode: values.joinCode })
                .then(function (_a) {
                var _b, _c;
                var data = _a.data;
                if (data) {
                    refreshAttendeeList();
                    var newGroup = groupData === null || groupData === void 0 ? void 0 : groupData.groupNames.find(function (g) { return g === values.groupName; });
                    formikHelpers.setSubmitting(false);
                    setConfirmationMessage({
                        title: "You're all set!",
                        subtitle: "You have joined ".concat(newGroup ? newGroup : "a new group"),
                    });
                    history.push(Constants.Routes.myAttendee
                        .replace(":clientKey", eventData.clientKey)
                        .replace(":urlKey", eventData.urlKey)
                        .replace(Constants.Regex.guid, "")
                        .replace(":attendeeId", attendee.id)
                        .replace(":orderKey", (_b = order === null || order === void 0 ? void 0 : order.orderKey) !== null && _b !== void 0 ? _b : "")
                        .replace(":groupNumber", (_c = group === null || group === void 0 ? void 0 : group.groupNumber.toString()) !== null && _c !== void 0 ? _c : "")
                        .replace(":eventNumber", eventData.eventNumber.toString()));
                }
            })
                .catch(function (err) {
                handleErrors(err, dispatch, formikContext, setGlobalError);
            })
                .finally(function () {
                formikHelpers.setSubmitting(false);
            });
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext, setGlobalError);
            formikHelpers.setSubmitting(false);
        });
    };
    if (!groupData) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) })), _jsx(Col, __assign({ xs: 12 }, { children: _jsx(Skeleton, { variant: "rect", width: "100%", className: "field-skeleton" }) }))] }) })));
    }
    var joinSchema = Yup.object().shape({
        groupName: Yup.string().required("Group is required"),
        joinCode: Yup.string().required("Passcode is required"),
    });
    return (_jsxs(_Fragment, { children: [(attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlockedAfter) && (_jsx(NoChangesAfterMessage, { changesAreBlocked: attendee.changesAreBlocked, changesAreBlockedAfter: attendee.changesAreBlockedAfter })), _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, formikBagProps: {
                    submitButtonLabel: "Change Group",
                    hideButton: (attendee === null || attendee === void 0 ? void 0 : attendee.status) === "Cancelled" || (attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked),
                }, validationSchema: joinSchema, useUnsavedPrompt: false }, { children: function (_a) {
                    var formikContext = _a.formikContext;
                    return (_jsx(_Fragment, { children: _jsxs(WidgetFieldset, __assign({ isDisabled: (attendee === null || attendee === void 0 ? void 0 : attendee.status) === "Cancelled" || (attendee === null || attendee === void 0 ? void 0 : attendee.changesAreBlocked) }, { children: [_jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.myAttendeeGroup], formikContext: formikContext, active: true, initialValues: {}, focusDelay: 500 }), _jsx(Form.Field, { label: "Search for an existing group", component: Form.Input.Select, id: "groupName", name: "groupName", data: groupData.groupNames.map(function (group) { return ({
                                        label: groupData.groupName === group ? "".concat(group, " (Current Group)") : group,
                                        value: group,
                                    }); }), autoComplete: "off", loadOptionsAsync: eventData.isGroupPrivate
                                        ? function (input, callback) {
                                            var results = [];
                                            if (input.length > 4) {
                                                if (!showGroupResults) {
                                                    setShowGroupResults(true);
                                                }
                                                groupData.groupNames.forEach(function (group) {
                                                    if (group.toLowerCase().includes(input.toLowerCase())) {
                                                        results.push({
                                                            label: group,
                                                            value: group,
                                                        });
                                                    }
                                                });
                                            }
                                            else if (showGroupResults) {
                                                setShowGroupResults(false);
                                            }
                                            callback(results);
                                        }
                                        : undefined, noOptionsMessage: eventData.isGroupPrivate
                                        ? function (input) {
                                            if (input.length > 4) {
                                                return "No Groups Found";
                                            }
                                            else {
                                                return "Type to search...";
                                            }
                                        }
                                        : undefined }), _jsx(Form.Field, { label: "Passcode to join this group", id: "joinCode", name: "joinCode", autoComplete: "new-off" }), _jsx("p", { children: "Don't know the passcode to join your group? Contact your group's manager." }), _jsxs("p", { children: ["Are you the manager and you forgot your passcodes?", " ", _jsx("a", __assign({ href: Constants.Routes.resetGroup
                                                .replace(":clientKey", eventData.clientKey)
                                                .replace(":urlKey", eventData.urlKey)
                                                .replace(":eventNumber", eventData.eventNumber.toString()), onClick: function (evt) {
                                                evt.preventDefault();
                                                history.push(Constants.Routes.resetGroup
                                                    .replace(":clientKey", eventData.clientKey)
                                                    .replace(":urlKey", eventData.urlKey)
                                                    .replace(":eventNumber", eventData.eventNumber.toString()));
                                            }, className: "pointer" }, { children: "Click here" })), "."] }), _jsx(Alert, __assign({ purpose: "info", className: "m-top-medium" }, { children: "Please note that by joining a group you are granting permission to the group manager to access your registration details and make changes on your behalf. If you do not wish to provide the group manager with access to your registration details, please do not join a group." }))] })) }));
                } }))] }));
};
export default MyAttendeeGroupChange;
